function isMockSession(session: string | null): boolean {
  return session !== null && session.endsWith('.nexus-mock-signature');
}

function clearMockSession(): void {
  const session = localStorage.getItem('local_session');
  if (isMockSession(session)) {
    localStorage.removeItem('local_session');
    delete (globalThis as any).iamSession;
  }
}

function checkMocksEnabled(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('mocks')) {
    const enabled = urlParams.get('mocks') === 'true';
    if (enabled) {
      sessionStorage.setItem('mocks', 'true');
    } else {
      sessionStorage.removeItem('mocks');
      clearMockSession();
    }
    return enabled;
  }
  if (sessionStorage.getItem('mocks') === 'true') return true;
  if (localStorage.getItem('mocks') === 'true') return true;
  return (globalThis as any).enableMocks === true;
}

export async function enableMocksIfNeeded(): Promise<void> {
  const mocksEnabled = checkMocksEnabled();

  if (!mocksEnabled) {
    clearMockSession();
    return;
  }

  try {
    const { startMSW } = await import('./browser');
    const started = await startMSW();
    if (!started) {
      sessionStorage.removeItem('mocks');
    }
  } catch (err) {
    console.error('[MSW] Failed to start, continuing without mocks:', err);
    sessionStorage.removeItem('mocks');
  }
}
